import React, { useContext } from 'react';
import {Link} from 'react-router-dom';
import { Typography } from 'antd';
import { InfoModalContext, InfoModalContextProvider } from '../context/InfoModalContext';

const InfoBanner = () => {
  const {toggleModal} = useContext(InfoModalContext)
  return (
    <div className="info-banner">
      <div className="text">
        <Typography.Title level={3}>
          How does this survey work?
        </Typography.Title>
        <ul>
          <li>In each image, we show the full body of an animal species and six questions</li>
          <li>You are asked to rate each question according to your impression of the species, regardless of whether or not you know the species in the image</li>
          <li>Every time you complete six questions and press Rate, a response is collected and a new species image will be loaded</li>
          <li>We have a total of 1,980 animals for you to discover. You can stop and continue at your own pace.</li>
          <li>We use cookies to help you track your progress</li>
          <li>If you like this survey, please consider sharing it around! Your contributions can help promote better and wider biodiversity conservation. If you want to know more, please visit our <Link onClick={() => toggleModal(false)} to="/about">Project</Link> page.</li>
        </ul>
      </div>
    </div>
  )
}

export default InfoBanner;